<ng-container
  *ngIf="merchandisingCarouselModel$ | async as merchandisingCarouselModel"
>
  <div
    class="data-cx-merchandising-carousel"
    [cxAttributes]="merchandisingCarouselModel.metadata"
    [cxAttributesNamePrefix]="'data-cx-merchandising-carousel'"
  ></div>
  <cx-carousel
    [items]="merchandisingCarouselModel.items$"
    [title]="title$ | async"
    [template]="carouselItem"
    itemWidth="285px"
  >
  </cx-carousel>

  <ng-template #carouselItem let-item="item">
    <div
      class="data-cx-merchandising-product"
      [cxAttributes]="item.metadata"
      [cxAttributesNamePrefix]="'data-cx-merchandising-product'"
    ></div>
    <a
      tabindex="0"
      [routerLink]="{ cxRoute: 'product', params: item } | cxUrl"
      (click)="
        onMerchandisingCarouselItemClick(merchandisingCarouselModel, item)
      "
    >
      <cx-media
        *ngIf="item.images?.PRIMARY"
        [container]="item.images.PRIMARY"
        format="product"
      >
      </cx-media>
      <h4>{{ item.name }}</h4>
      <div class="price">
        {{ item.price?.formattedValue }}
      </div>
      <div class="price" *ngIf="item.stock?.stockLevel > 0; else outOfStock">
        {{ item.stock?.stockLevelStatus }} : {{ item.stock?.stockLevel }}
      </div>
      <ng-template #outOfStock>
        <div class="price">
          {{ item.stock?.stockLevelStatus }}
        </div>
      </ng-template>
    </a>
  </ng-template>
</ng-container>
